import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Formik } from 'formik';
import { useMutation } from '@apollo/client';
import toast from 'react-hot-toast';

import DataState from '../DataState';
import {
  TitleContainer,
  Title,
} from '../../elements';

import Form from './Form';
import { CREATE_OWNER_PORTAL_USER } from './queries';
import { userSchema } from './schemas';

const NewUser = () => {
  const [formSubmitting, setFormSubmitting] = useState(false);
  const navigate = useNavigate();

  const [createOwnerPortalUser] = useMutation(CREATE_OWNER_PORTAL_USER, {
    onCompleted: () => {
      toast('An email with instructions is being sent to the new user.');
      navigate('/users');
    }
  });

  const handleSubmit = values => {
    setFormSubmitting(true);

    const {
      firstName, lastName, email, mobilePhone, officePhone,
      ...ownerPortalUser
    } = values;

    ownerPortalUser.portalUserAttributes = {
      firstName, lastName, email, mobilePhone, officePhone
    };

    createOwnerPortalUser({ variables: ownerPortalUser });
  };

  return (
    <>
      <Helmet>
        <title>Add User</title>
      </Helmet>

      <TitleContainer>
        <Title>Add User</Title>
      </TitleContainer>

      {formSubmitting ? <DataState.Loading /> : (
        <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            email: '',
            mobilePhone: '',
            officePhone: '',
            role: 'Normal',
          }}
          validationSchema={userSchema}
          onSubmit={handleSubmit}
        >
          <Form formSubmitting={formSubmitting} />
        </Formik>
      )}
    </>
  );
};

export default NewUser;
